import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Stack, Warning } from "@phosphor-icons/react";
import { LOGO_URL, LOGIN_HERO } from "@/lib/brand";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("stanescu.emilian@gmail.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      const from = location.state?.from;
      const dest = from ? `${from.pathname || "/"}${from.search || ""}` : "/";
      navigate(dest, { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen bg-background lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img src={LOGIN_HERO} alt="" className="h-full w-full object-cover opacity-45" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-white/10 bg-black/40 px-3 py-1 text-xs font-medium text-muted-foreground backdrop-blur-xl">
            Highberg Solution
          </div>
          <h2 className="font-head text-4xl font-extrabold leading-tight tracking-tighter">
            Ciclul complet <br />
            <span className="text-primary">al proiectului</span>, într-un dosar digital.
          </h2>
        </div>
      </div>

      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm fade-up">
          <div className="mb-8">
            <img src={LOGO_URL} alt="Highberg" className="h-12 w-auto max-w-[210px] object-contain object-left" style={{ mixBlendMode: "screen" }} />
            <div className="mt-2 text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              HGS-OPEP · Operational Excellence Platform
            </div>
          </div>

          <h1 className="font-head text-2xl font-bold tracking-tight">Autentificare</h1>
          <p className="mb-6 mt-1 text-sm text-muted-foreground">Introdu datele de acces pentru a continua.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                required
              />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Parolă</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                placeholder="••••••••"
                required
              />
            </div>

            {error && (
              <div
                className="flex items-center gap-2 rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-400"
                data-testid="login-error"
              >
                <Warning size={16} weight="bold" /> {error}
              </div>
            )}

            <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit">
              {loading ? "Se conectează…" : "Conectare"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
